import moment from 'moment';

export const formatRelativeTimeText = (value, locale = 'en') => {
	if (!value || typeof value.fromNow !== 'function') return '';

	const relativeText = value.clone().locale(locale).fromNow();

	if (locale !== 'en') return relativeText;
	if (relativeText === 'a year ago') return '1 year ago';
	if (relativeText === 'in a year') return 'in 1 year';

	return relativeText;
};

export const getRelativeTimeFromNow = (input, locale = 'en') => {
	const value = moment.isMoment(input) ? input : moment(input);

	if (!value.isValid()) return '';

	return formatRelativeTimeText(value, locale);
};